import { createFileRoute } from "@tanstack/react-router";
import { useJobTypeDrawerContext } from "@/utils/job-type-detail/job-type-drawer-context";
import { JobTypeLifecycleSection } from "./fullLifecycle";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/lifecycle",
)({
	component: OrgJobTypeLifecycleTab,
});

function OrgJobTypeLifecycleTab() {
	const { jobType } = useJobTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<JobTypeLifecycleSection jobType={jobType} scope="organization" />
		</div>
	);
}
